// 登录
<template>
  <div class="login">
    <van-nav-bar
      @click-left="$router.go(-1)"
      left-arrow
      fixed
      placeholder
      right-text="Forget the password"
      @click-right="$router.push('forget')">
    </van-nav-bar>
    <section class="content">
      <div class="h1">Log in</div>
      <!-- <div class="h2">Start your Arctic Dolphin journey</div> -->
      <!-- <div class="h3">Registering and logging in means that you have agreed to the</div> -->
      <!-- <div class="h4">{{ '<' + 'user agreement' + '>' }}</div> -->
    </section>
    <section class="form">
      <van-form @submit="onSubmit">
        <van-field
          v-model="form.email"
          :left-icon="require('@/assets/images/icon/email.png')"
          name="email"
          :placeholder="$t('placeholder.email')"
        />
        <van-field
          v-model="form.password"
          :left-icon="require('@/assets/images/icon/password.png')"
          name="password"
          type="password"
          :placeholder="$t('placeholder.password')"
        />
        <div style="margin: 24px 25px 0;">
          <van-button class="submit" :loading="loading" block round size="large" color="linear-gradient(30deg, #3EE191, #24DEDD)" type="info" native-type="submit">
            {{ $t('register.login') }}
          </van-button>
          <van-button class="cancel" block round size="large" color="#282828" type="info" plain native-type="button" @click="$router.push('register')">
            {{ $t('register.register') }}
          </van-button>
        </div>
      </van-form>
    </section>
  </div>
</template>

<script>
import { login, customerInfo } from '@/api'
import { setCookies, getCookies } from '@/libs/util'
export default {
  name: 'Register',
  data () {
    return {
      loading: false,
      form: {
        email: '',
        password: ''
      }
    }
  },
  created () {
    console.log(getCookies('account'))
    if (getCookies('account')) {
      this.form = JSON.parse(getCookies('account'))
    }
  },
  methods: {
    // 邮箱验证
    validatorEmail (value) {
      const reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
      return reg.test(value)
    },
    // 表单提交
    onSubmit () {
      if (!this.form.email) {
        this.$toast(this.$t('placeholder.email'))
        return
      } else {
        // 邮箱验证
        if (!this.validatorEmail(this.form.email)) {
          this.$toast(this.$t('placeholder.email'))
          return
        }
      }
      if (!this.form.password) {
        this.$toast(this.$t('placeholder.password'))
        return
      }
      this.loading = true
      login({
        email: this.form.email,
        imie: this.$store.state.app.imie,
        password: this.$md5(this.form.password).toUpperCase()
      }).then(res => {
        sessionStorage.setItem('token', res.data.token)
        this.$store.commit('setToken', res.data.token)
        setCookies('account', this.form, 30)
        if (window.webkit) {
          this.$store.commit("setFirstTimeGetIntoDeviceListPage", true);
          window.webkit.messageHandlers.whenTokenReceived.postMessage(res.data.token) // 向宿主发送token
        }

        customerInfo().then(res => {
          console.log('顾客信息', res.data)
          sessionStorage.setItem('userInfo', JSON.stringify(res.data))
          this.$store.commit('setUserInfo')
        })
        this.$router.push('home')
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less">
  .login {
    box-sizing: border-box;
    min-height: 100vh;
    height: 100%;
    .content {
      padding: 30px;
      .h1 {
        font-size: 50px;
        font-weight: bold;
        margin-top: 40px;
      }
      .h2 {
        font-size: 28px;
        font-weight: bold;
        margin-top: 10px;
      }
      .h3 {
        font-size: 18px;
        margin-top: 10px;
      }
      .h4 {
        font-size: 18px;
        font-weight: bold;
        margin-top: 10px;
      }
    }
    .van-cell {
      background: transparent;
      padding: 30px 40px;
      &:after {
        border-color: #D2D2D2;
      }
    }
    .van-nav-bar {
      .van-nav-bar__title {
        color: #000;
        width: 80%;
        max-width: 80%;
        font-weight: normal!important;
      }
      .van-nav-bar__right {
        font-size: 22px;
        .van-nav-bar__text {
          color: #000;
        }
      }
    }
    .van-field__label {
      color: #c8c9cc;
    }
    .cancel {
      margin-top: 30px;
    }
  }
</style>
